<template>
  <div class="footer-container">
    <el-row>
      <el-col>
        <div class="footer">
          <div class="footer-main">
            <section class="links-wrap">
              <div class="links clearfix">
                <div class="links-box clearfix">
                  <p class="links-title">产品中心</p>
                  <ul class="links-list clearfix">
                    <li class="links-item">
                      <a :href="`${baseLink}`" title="同步备课" target="_blank">同步备课</a>
                    </li>
                    <li class="links-item">
                      <a :href="`${baseLink}fuxi/`" title="复习备考" target="_blank">复习备考</a>
                    </li>
                    <!-- <li class="links-item">
                      <a href="//yxt.51jiaoxi.com/" title="云校通" target="_blank">云校通</a>
                    </li> -->
                    <li class="links-item">
                      <a :href="`${baseLink}yw/bk_z99_s1/`" title="素材专区" target="_blank">素材专区</a>
                    </li>
                    <li class="links-item">
                      <a :href="`${baseLink}latest-docs/`" title="最新资料" target="_blank">最新资料</a>
                    </li>
                    <li class="links-item">
                      <a :href="`${baseLink}latest-topics/`" title="最新专题" target="_blank">最新专题</a>
                    </li>
                  </ul>
                </div>
                <div class="links-box clearfix">
                  <p class="links-title">帮助中心</p>
                  <ul class="links-list">
                    <li class="links-item">
                      <a :href="`${baseLink}user/recharges/`" title="充值中心" target="_blank">充值中心</a>
                    </li>
                    <li class="links-item">
                      <a :href="`${baseLink}common/help/`" title="常见问题" target="_blank">常见问题</a>
                    </li>
                    <li class="links-item">
                      <a :href="`${baseLink}common/feedback/`" title="意见反馈" target="_blank">意见反馈</a>
                    </li>
                  </ul>
                </div>
                <div class="links-box clearfix">
                  <p class="links-title">关于我们</p>
                  <ul class="links-list">
                    <li class="links-item">
                      <a :href="`${baseLink}common/about/`" title="了解我们" target="_blank">了解我们</a>
                    </li>
                    <li class="links-item">
                      <a :href="`${baseLink}common/about/`" title="联系我们" target="_blank">联系我们</a>
                    </li>
                    <li class="links-item">
                      <a :href="`${baseLink}article-5396.html`" title="兼职招聘" target="_blank" class="hot">兼职招聘</a>
                    </li>
                  </ul>
                </div>
                <div class="links-box clearfix hover-img-box">
                  <p class="links-title">关注我们</p>
                  <ul class="links-list">
                    <li class="links-item">
                      <a
                        href="javascript:void(0)"
                        class="hover-wechat"
                        @mouseenter="handleHover('wechat')"
                        @mouseleave="handleUnHover('wechat')"
                        target="_blank"
                        >官方微信</a
                      >
                    </li>
                    <li class="links-item">
                      <a href="//weibo.com/jiaoxiwang" title="官方微博" target="_blank">官方微博</a>
                    </li>
                    <li class="links-item">
                      <a href="javascript:void(0)" class="hover-qq" @mouseenter="handleHover('qq')" @mouseleave="handleUnHover('qq')" target="_blank"
                        >官方Q群</a
                      >
                    </li>
                  </ul>
                  <div class="img-box">
                    <img src="../assets/images/erqq.png" alt class="qq" width="100" v-show="showFlag.qq" />
                    <img src="../assets/images/erwx.png" alt class="wechat" width="100" v-show="showFlag.wechat" />
                  </div>
                </div>
                <div class="wechat-box">
                  <img src="../assets/images/footer-wechat-text.png" alt="关注微信公众号" title="关注微信公众号" class="text" />
                  <img src="../assets/images/erwx.png" alt="微信公众号" title="微信公众号" class="QR" width="100" />
                </div>
              </div>
            </section>
            <section class="bottom">
              <span class="text">Copyright © 2018 51jiaoxi.com 深圳智学帮科技有限公司粤ICP备19008911号</span>
              <a :href="`${baseLink}common/privacy/`" class="link-one" target="_blank" title="隐私政策">隐私政策</a>
              <a :href="`${baseLink}common/legalNotice/`" target="_blank" title="法律声明">法律声明</a>
            </section>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
var that
import { mapGetters } from 'vuex'
import * as util from '../utils/util.js'
export default {
  name: 'footerPage',
  data() {
    return {
      showFlag: {
        wechat: false,
        qq: false,
      },
    }
  },
  computed: {
    ...mapGetters(['baseLink']),
  },
  created() {
    that = this
  },
  methods: {
    handleHover(flag) {
      that.showFlag[flag] = true
    },
    handleUnHover(flag) {
      that.showFlag[flag] = false
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.footer-container {
  width: 100%;
  background-color: #e6e6e6;
  overflow: hidden;
  & .footer {
    width: 100%;
    height: 100%;
    & > .footer-main {
      position: relative;
      box-sizing: border-box;
      width: 1200px;
      min-width: 1200px;
      height: 100%;
      margin: 0 auto;
      a:hover {
        color: #2b99ff;
      }
      .links-wrap {
        height: 100%;
        .links {
          padding: 35px 0;
          .links-box {
            text-align: left;
            float: left;
            margin-right: 100px;
            &:last-child {
              margin-right: 0;
            }

            .links-title {
              margin: 0;
              margin-bottom: 10px;
              font-size: 14px;
              color: #333333;
              line-height: 20px;
            }

            .links-list {
              margin: 0;
              writing-mode: vertical-lr;
              height: 60px;

              .links-item {
                float: left;
                line-height: 17px;
                font-size: 12px;
                width: 70px;
                writing-mode: horizontal-tb;
                margin-bottom: 4px;

                &:nth-child(3n) {
                  margin-bottom: 0;
                }

                a {
                  color: #666;

                  &:hover {
                    color: #2b99ff;
                  }
                }

                .hot {
                  color: #f60;

                  &:hover {
                    line-height: 17px;
                    font-size: 12px;
                    color: #2b99ff;
                  }
                }
              }
            }
          }

          .wechat-box {
            float: right;
            img {
              vertical-align: middle;
              border-style: none;
            }
            .QR {
              margin-left: 20px;
            }
          }

          .hover-img-box {
            position: relative;

            .img-box {
              position: absolute;
              top: 0;
              right: 0;
              transform: translateX(100%);
              img {
                margin-left: 20px;
              }
            }
          }
        }
      }
      .bottom {
        height: 52px;
        line-height: 52px;
        border-top: 1px solid #ddd;
        background-color: #e5e5e5;
        text-align: center;
        font-size: 0;
        a {
          padding-left: 13px;
          color: #666 !important;
          font-size: 12px;
          &:hover {
            color: #2b99ff !important;
          }
        }
        .text {
          padding-right: 13px;
          border-right: 1px solid grey;
          color: grey;
          font-size: 12px;
        }
        .link-one {
          padding: 0 13px;
          border-right: 1px solid grey;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
